import React from 'react';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { Switch } from '@shared/ui/atoms/Switch';
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { BodyRegular, BodySmall } from '@shared/ui/atoms/fonts/Body';
import { HospitalityOrderItem } from "../../../../meeting-rooms/models/hospitality.models";
import { useDispatch } from "react-redux";
import { updateOrderItem } from "../data/hospitality-management.duck";
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { DialogIdentifiers, openDialogWithPayload } from "@shared/store/dialog.duck";

export function HospitalityMenuItem(props: Props) {
  const dispatch = useDispatch();

  const onEnabledChange = async (value: boolean) => {
    const updatedOrderItem = {...props.item, enabled: value};
    dispatch(updateOrderItem({orderItem: updatedOrderItem, office: props.office}));
  }

  const onEditClicked = async () => {
    dispatch(openDialogWithPayload({
      payload: { office: props.office, orderItem: props.item },
      activeDialog: DialogIdentifiers.HospitalityCreateOrderItemDialog
    }));
  }

  return (
    <Container>
      <Content>
        <SpaceBetweenRow>
          <Column>
            <BodyRegular weight={600}>{props.item.label}</BodyRegular>
            <BodySmall className={'hospitalityMenuItem__description'}>{props.item.description}</BodySmall>
          </Column>
          <BodyRegular weight={600}>{props.item.currency}{props.item.price.toFixed(2)}</BodyRegular>
        </SpaceBetweenRow>
        <IconButton icon={IconTypes.Edit} color={'darkGrey'} onClick={onEditClicked} />
      </Content>
      <SwitchWrapper>
        <Switch value={props.item.enabled} onChange={onEnabledChange} />
      </SwitchWrapper>
    </Container>
  )
}

interface Props {
  item: HospitalityOrderItem;
  office: OfficeEntity;
}

const Container = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
`

const SpaceBetweenRow = styled.div`
  display: flex;
  justify-content: space-between;
`

const Content = styled.div`
  border-radius: 8px;
  border: 1px solid ${Colours.lightGrey};
  background: white;
  padding: 16px 48px 16px 32px;
  flex: 1;
  
  margin-right: 32px;
  position: relative;
  .hospitalityMenuItem__description {
    font-style: italic;
  }
  .iconButton__button {
    position: absolute;
    right: 4px;
    bottom: 4px;
  }
`

const SwitchWrapper = styled.div`
  display: flex;
  justify-content: center;
`
